
// eslint-disable-next-line no-unused-vars
import { ConfigMetaData } from '@/types'
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

var globalThis = require('globalthis')() // returns native globalThis if compliant

@Component({
  computed: {
    ...mapGetters({
      getConfigMetadata: 'getConfigMetadata',
      getDarkMode: 'getDarkMode',
    }),
  },
  methods: {
    ...mapActions({
      fetchCfgMetadataFromFileOrLocalServer:
        'fetchCfgMetadataFromFileOrLocalServer',
    }),
  },
})
export default class ConfigInfoBar extends Vue {
  //Vuex getters
  private getConfigMetadata!: ConfigMetaData
  private getDarkMode!: boolean

  //Vuex actions
  private fetchCfgMetadataFromFileOrLocalServer!: () => Promise<any>

  async loadMetadata() {
    Promise.all([
      await this.fetchCfgMetadataFromFileOrLocalServer(), // note the "await"
    ])
      .catch((err) => {
        console.log(err)
      })
      .finally(async () => {})
  }

  created() {
    if (globalThis.devEnvironment) this.loadMetadata()
  }
}
